// NOTE (Bruno 9-02-2020): these defaults are added, here as opposed to on the
// Organization client-side model, because importing said model here breaks the app
// for some currently-unknown reason.

// NOTE (Bruno 9-03-2020): for documentation, see
// https://aspireperks.atlassian.net/wiki/spaces/CAN/pages/646250500/Organization+Custom-Variables+CV+Documentation

import { $gettext } from '@/services/translations'
import { currencyFormat } from '@/services/utils'

const variables = [
  {
    name: 'cv1',
    template: '{{cv1}}',
    default: $gettext('my organization', 'en_US'),
    defaultEs: $gettext('my organization', 'es_ES'),
  },
  {
    name: 'cv2',
    template: '{{cv2}}',
    default: `${$gettext('colleagues', 'en_US')}`,
    defaultEs: $gettext('colleagues', 'es_ES'),
  },
  {
    name: 'cv3',
    template: '{{cv3}}',
    default: $gettext('employee', 'en_US'),
    defaultEs: $gettext('employee', 'es_ES'),
  },
  {
    name: 'cv4',
    template: '{{cv4}}',
    default: $gettext('The Workers Lab, the Grant Circle’s nonprofit fiscal sponsor', 'en_US'),
    defaultEs: $gettext('The Workers Lab, the Grant Circle’s nonprofit fiscal sponsor', 'es_ES'),
  },
  {
    name: 'cv7',
    template: '{{cv7}}',
    default: $gettext('working for', 'en_US'),
    defaultEs: $gettext('working for', 'es_ES'),
  },
  {
    name: 'cv8',
    template: '{{cv8}}',
    default: $gettext('the past 12 months', 'en_US'),
    defaultEs: $gettext('the past 12 months', 'es_ES'),
  },
]
function orgVars(org, lang) {
  return [
    {
      template: '%{organization.name}',
      value: org.name,
    },
    {
      template: '%{organization.grantLimit}',
      value: currencyFormat(org.grantLimit, lang, true),
    },
    {
      template: '%{organization.supportEmail}',
      value: org.supportEmail,
    },
    {
      template: '%{organization.rollingGrantDuration}',
      value: org.rollingGrantDuration,
    }
  ]
}

export function customVariablesFilter(text, orgCVs, lang) {
  let output = text
  for (let variable of variables) {
    const defaultVar = lang === 'es_ES' ? variable.defaultEs : variable.default
    let replacement = orgCVs[variable.name] || defaultVar
    output = output.split(variable.template).join(replacement)
  }
  return output
}

export function customVariablesFromBackendTranslationFilter(text, textEs, orgCVs, lang) {
  let output = lang === 'es_ES' ? textEs : text
  for (let variable of variables) {
    const defaultVar = lang === 'es_ES' ? variable.defaultEs : variable.default
    let replacement = orgCVs[variable.name] || defaultVar
    output = output.split(variable.template).join(replacement)
  }
  return output
}

export function getDefaultForCustomVariable(varName, language) {
  for (let variable of variables) {
    if (variable.name === varName) {
      if (language === 'en_US') {
        return variable.default
      } else {
        return variable.defaultEs
      }
    }
  }
  throw Error('Invalid argument: varName at getDefault()')
}

export function getVariableReplacement(text, textEs, org, lang) {
  let output = lang === 'es_ES' ? textEs : text

  for (let variable of variables) {
    const defaultVar = lang === 'es_ES' ? variable.defaultEs : variable.default
    let replacement = org.customVariables[variable.name] || defaultVar
    output = output.split(variable.template).join(replacement)
  }

  for (let orgVar of orgVars(org, lang.replace('_', '-'))) {
    output = output.replaceAll(orgVar['template'], orgVar['value'])
  }
  return output
}
